<script>

///Ultima alteração: 06/07/2020
///Alterado por: Allinne

	// Componentes
	import { alt }          from './../store.js';		
	import HeaderItem       from './Header__Item.svelte';

	// Code
	export let logo 		    = "";
	export let logoMobile 	    = logo;
	export let logoHeight       = "55px";
	export let logoWidth        = "auto"
	export let style            = "";

	export let menu 	        = [];
	export let menuSecondary 	= [];
</script>

<header class="header header-follower header--landing header--{style}">
	<div class="container">
		<nav class="navbar-expand-lg navbar">
			<a class="logo navbar-brand d-lg-none" href="/" title="Home">
				<img class="img-fluid d-lg-none" src="{logoMobile}" alt="Logo{$alt}" width="{logoWidth}" style="height: {logoHeight};">
			</a>
			<button class="navbar-toggler" data-toggle="collapse" data-target=".navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Alterna navegação">
				<div class="navbar-toggler-icon">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>                        
				</div>
			</button>
			<div class="navbar-collapse collapse align-items-center">
				<ul class="navbar-nav menu w-100 justify-content-between">
					{#each menu as item}
						<HeaderItem classe="icon-transform" {...item} />
					{/each}
					<a class="logo d-none d-lg-block ml-10" href="/" title="Home">
						<img class="img-fluid" src="{logo}" alt="Logo{$alt}" width="{logoWidth}" style="max-height: {logoHeight};">
					</a>   
					{#each menuSecondary as item}
						<HeaderItem classe="icon-transform" {...item} />
					{/each}
				</ul>
			</div>
		</nav>
	</div>
</header>

<style type="text/sass">
@import '../sass/variables.sass'

/* Header */
header 
	.navbar 
		padding: 0
		.logo
			padding: 0
			img
				+transition(max-height 0.4s ease)
		.menu 
			align-items: center

/* Menu Mobile */
.navbar-toggler
	.navbar-toggler-icon
		position: relative
		span
			background-color: #000
			display: block
			height: 3px
			position: absolute
			transform-origin: center
			transition-duration: 86ms
			transition-property: background-color,opacity,transform
			transition-timing-function: ease-out
			width: 25px
			&:nth-child(1)
				top: calc(50% - 10px)
			&:nth-child(2)
				top: calc(50% - 1px)
			&:nth-child(3)
				top: calc(50% + 8px)
	&[aria-expanded="true"]
		.navbar-toggler-icon span
			&:nth-child(1)
				transform: translateY(10px) rotate(45deg)
			&:nth-child(2)
				opacity: 0
			&:nth-child(3)
				transform: translateY(-8px) rotate(-45deg)
</style>